import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";

/**
 * 将图片链接转换成 DataURL
 * @param imageUrl 图片链接
 */
export function imageToDataURL(imageUrl) {
  return new Promise(function (resolve, reject) {
    var imageElement = new Image();
    imageElement.crossOrigin = 'anonymous';
    imageElement.referrerPolicy = 'no-referrer';

    imageElement.onload = function () {
      try {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        canvas.width = imageElement.width;
        canvas.height = imageElement.height;
        ctx.drawImage(imageElement, 0, 0); // 始终转换成 PNG 格式
        // TODO: 根据 `imageUrl` 识别原始图片格式？

        var imageDataURL = canvas.toDataURL('image/png');
        resolve({
          imageElement: imageElement,
          imageDataURL: imageDataURL
        });
      } catch (err) {
        reject();
      }
    };

    imageElement.onerror = reject;
    imageElement.src = imageUrl;
  });
}